import { useEffect, useState } from 'react';

export const COUNTRY_CODES = [
  { cc: '32', flag: '🇧🇪', name: 'Belgique' },
  { cc: '33', flag: '🇫🇷', name: 'France' },
  { cc: '31', flag: '🇳🇱', name: 'Pays-Bas' },
  { cc: '352', flag: '🇱🇺', name: 'Luxembourg' },
  { cc: '49', flag: '🇩🇪', name: 'Allemagne' },
  { cc: '34', flag: '🇪🇸', name: 'Espagne' },
  { cc: '351', flag: '🇵🇹', name: 'Portugal' },
  { cc: '39', flag: '🇮🇹', name: 'Italie' },
  { cc: '44', flag: '🇬🇧', name: 'Royaume-Uni' },
  { cc: '41', flag: '🇨🇭', name: 'Suisse' },
  { cc: '212', flag: '🇲🇦', name: 'Maroc' },
  { cc: '213', flag: '🇩🇿', name: 'Algérie' },
  { cc: '216', flag: '🇹🇳', name: 'Tunisie' },
  { cc: '90', flag: '🇹🇷', name: 'Turquie' },
  { cc: '48', flag: '🇵🇱', name: 'Pologne' },
  { cc: '40', flag: '🇷🇴', name: 'Roumanie' },
  { cc: '1', flag: '🇺🇸', name: 'USA / Canada' },
];

// Découpe une valeur E.164 (+32493…) en { cc, local }
const split = (value) => {
  const digits = (value || '').replace(/\D/g, '');
  if (!digits) return { cc: '32', local: '' };
  const hit = [...COUNTRY_CODES].sort((a, b) => b.cc.length - a.cc.length).find(c => digits.startsWith(c.cc));
  if ((value || '').trim().startsWith('+') && hit) return { cc: hit.cc, local: digits.slice(hit.cc.length) };
  return { cc: '32', local: digits.replace(/^0+/, '') };
};

export const toE164 = (cc, local) => {
  const d = (local || '').replace(/\D/g, '').replace(/^0+/, '');
  return d ? `+${cc}${d}` : '';
};

// Champ téléphone : sélecteur d'indicatif + numéro local → onChange('+32493328862')
export const PhoneInput = ({ value, onChange, testId = 'phone-input', autoFocus = false, required = true }) => {
  const init = split(value);
  const [cc, setCc] = useState(init.cc);
  const [local, setLocal] = useState(init.local);

  useEffect(() => { onChange(toE164(cc, local)); }, [cc, local]); // eslint-disable-line react-hooks/exhaustive-deps

  const onLocal = (raw) => {
    // Si l'utilisateur colle un numéro complet (+33…, 0033…), on reprend l'indicatif
    const trimmed = raw.trim();
    if (trimmed.startsWith('+') || trimmed.startsWith('00')) {
      const s = split(trimmed.startsWith('00') ? '+' + trimmed.slice(2) : trimmed);
      setCc(s.cc);
      setLocal(s.local);
      return;
    }
    setLocal(raw.replace(/[^\d\s]/g, ''));
  };

  return (
    <div className="flex gap-2" data-testid={testId}>
      <select
        value={cc}
        onChange={(e) => setCc(e.target.value)}
        className="input-field w-[7.5rem] shrink-0 px-2 text-sm"
        data-testid={`${testId}-cc`}
        aria-label="Indicatif"
      >
        {COUNTRY_CODES.map(c => (
          <option key={c.cc} value={c.cc}>{c.flag} +{c.cc}</option>
        ))}
      </select>
      <input
        type="tel"
        inputMode="tel"
        value={local}
        onChange={(e) => onLocal(e.target.value)}
        required={required}
        autoFocus={autoFocus}
        placeholder={cc === '32' ? '493 32 88 62' : 'Numéro sans le 0'}
        className="w-full input-field"
        data-testid={`${testId}-local`}
      />
    </div>
  );
};
